(() => {
  if (window.jgComplementaryProductsLoaded) return;
  window.jgComplementaryProductsLoaded = true;

  const loadComplementaryProducts = async (element) => {
    if (element.dataset.loading === 'true') return;

    const productId = element.dataset.productId;
    const sectionId = element.dataset.sectionId;
    const blockId = element.dataset.jgBlockId;
    const baseUrl = element.dataset.url;

    if (!productId || !sectionId || !blockId || !baseUrl) {
      console.error('[JG Complementary] Missing required parameters:', {
        productId,
        sectionId,
        blockId,
        baseUrl
      });
      return;
    }

    element.dataset.loading = 'true';

    try {
      const url = new URL(baseUrl, window.location.origin);

      url.searchParams.set('product_id', productId);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('limit', element.dataset.limit || '10');
      url.searchParams.set('intent', element.dataset.intent || 'complementary');

      const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`Recommendation request failed: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const source = Array.from(
        doc.querySelectorAll('[data-jg-complementary]')
      ).find((item) => item.dataset.jgBlockId === blockId);

      if (!source) {
        throw new Error('Complementary block was not found in Shopify response.');
      }

      const sourceContent = source.querySelector(
        '.complementary-products__container'
      );

      if (!sourceContent) {
        element.innerHTML = '';
        element.hidden = true;
        return;
      }

      element.innerHTML = source.innerHTML;
      element.hidden = false;

      element.dispatchEvent(
        new CustomEvent('jg:complementary-loaded', {
          bubbles: true
        })
      );

    } catch (error) {
      console.error('[JG Complementary]', error);
    } finally {
      element.dataset.loading = 'false';
    }
  };

  const init = () => {
    document
      .querySelectorAll('[data-jg-complementary]')
      .forEach((element) => {
        loadComplementaryProducts(element);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();